import { FC } from 'react';
import {
    Balloon,
    ButtonBlack,
    Description,
    Duck,
    GradientBg,
    GreenSphere,
    HeaderContent,
    KBalloon,
    Title,
    VioletSphere,
} from './styled';
import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';
import { KidsCoursesSettings } from 'types';

interface HeaderProps {
    settings: KidsCoursesSettings | null;
}

export const Header: FC<HeaderProps> = ({ settings }) => {
    const { t } = useTranslation('pages/kids-courses');

    return (
        <>
            <GradientBg>
                <GreenSphere />
                <VioletSphere />
            </GradientBg>

            <HeaderContent>
                <Title>{settings?.title}</Title>
                <Description
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(settings?.description || ''),
                    }}
                />
                <ButtonBlack
                    onClick={() =>
                        (window.location.href = 'mailto:academy@kaspersky.com')
                    }
                    color={'primary'}>
                    {t('contact')}
                </ButtonBlack>

                <Duck
                    src={'/assets/images/kids-courses/duck.png'}
                    alt={'Rubber duck'}
                />

                <KBalloon
                    src={'/assets/images/kids-courses/kas-baloon.png'}
                    alt={'Kaspersky balloon'}
                />

                <Balloon
                    src={'/assets/images/kids-courses/baloon.png'}
                    alt={'Balloon'}
                />
            </HeaderContent>
        </>
    );
};
